<template>
  <!-- ==================== Spike-mark glyph ====================
    운영 어시스턴트 식별 glyph. 외부 폰트/CDN/Anthropic 자산 의존 0의 inline SVG.
    색상은 currentColor를 따르므로 부모가 color 토큰으로 제어한다. -->
  <svg
    class="spike-mark"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <!-- 말풍선 본체 -->
    <path
      fill="currentColor"
      d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9.5L5 20.5V17H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
    />
    <!-- 중앙 spike(스파크) 마크 — 4점 별. 파싱 안전한 정수 좌표 -->
    <path
      fill="var(--color-white, #fff)"
      d="M12 6 L13 10 L17 11 L13 12 L12 16 L11 12 L7 11 L11 10 Z"
    />
  </svg>
</template>

<script>
/**
 * @component SpikeMark
 * @description 어시스턴트 FAB용 stateless glyph 컴포넌트. props/state 없음.
 */
export default {
  name: 'SpikeMark'
}
</script>

<style scoped>
.spike-mark {
  display: block;
}
</style>
